module.exports = __webpack_public_path__ + "media/ruban.12f1a539.webm";